// --------------- GLOBAL CONSTANTS ---------------

export const themeColor            = "#2681A9";
export const themeColorLight       = "#E9F2F6";
export const themePink             = "#a92675ff";
export const themePinkLight        = "#f6e9f0ff";
export const themeColorGold        = "#B19055";
export const themeGold             = "#B19055";
export const themeColorGoldLight   = "#f7f4ee";
export const themeGoldLight        = "#f7f4ee";
export const themeGreen            = "#61CE70";
export const themeGreenLight       = "#9fe3a8ff";
export const themeRed              = "#b41e1eff";
export const themeGray             = "#a0a0a0ff";
export const themeLightGray = "#ebebeb"


document.documentElement.style.setProperty("--theme-green", themeColor);
document.documentElement.style.setProperty("--theme-blue", themeGold);
document.documentElement.style.setProperty("--theme-red", themeRed);
document.documentElement.style.setProperty("--theme-gray", themeGray);

export const blueButton = {backgroundColor: themeColor, color: 'white', border: 'none'};
export const goldButton = {backgroundColor: 'transparent', color: themeGold, border: 'none'};
export const modalTitle = {color: themeColor, fontSize: 18, fontWeight: 'bold'};
export const modalLabel = {color: themeGold, fontSize: 18, fontWeight: 600};
export const ContainerTitle = {color: themeColor, fontSize: 20, fontWeight: 700, margin: 0};
export const chartTitle = {color: themeColor, fontSize: 16, fontWeight: 600, background: themeColorLight, color: themeColor, justifyContent: 'space-between', display: 'flex', alignItems: 'center'};
export const tableTR = {
  backgroundColor: themeColor,
  color: 'white',
  border: `1px solid ${themeColor}`
};
export const tableTH = {
  padding: "10px",
  // background: "#f1f5f9",
  fontSize: 14,
  textAlign: "center",
  whiteSpace: "nowrap",
};;
export const tableTD = {
  padding: "10px",
  fontSize: 14,
  whiteSpace: "nowrap",
  textAlign: "center",
};

export const downloadTemplateData = [
      [
        {
          value: "NATIONALITY",
          fontWeight: "bold",
        },
        {
          value: "PASSPORT",
          fontWeight: "bold",
        },
        {
          value: "MOBILE",
          fontWeight: "bold",
        },
        {
          value: "NAME_EN",
          fontWeight: "bold",
        },

        {
          value: "NAME_AR",
          fontWeight: "bold",
        },
        {
          value: "AWQAF",
          fontWeight: "bold",
        },
        {
          value: "QID",
          fontWeight: "bold",
        },
        {
          value: "SRNO",
          fontWeight: "bold",
        },
        {
          value: "GENDER",
          fontWeight: "bold",
        },
        {
          value: "PASSPORT_EXPIRY (dd.mm.yyyy)",
          fontWeight: "bold",
        },
      ],
      [
        {
          type: String,
          value: "قطر",
        },
        {
          type: String,
          value: "1234567",
        },
        {
          type: String,
          value: "55712345",
        },
        {
          type: String,
          value: "Hamlat Al Marwa",
        },
        {
          type: String,
          value: "حملة المروة",
        },
        {
          type: String,
          value: "123456",
        },
        {
          type: String,
          value: "28987654321",
        },
        {
          type: Number,
          value: 1,
        },
        {
          type: String,
          value: "M/F",
        },
        {
          type: String,
          value: "dd.mm.yyyy",
        },
      ],
];

export const downloadGroupUserListTemplateData = [
      [
        {
          value: "SRNO",
          fontWeight: "bold",
        },
        {
          value: "GROUP_ID",
          fontWeight: "bold",
        },
        {
          value: "PLAN_NAME",
          fontWeight: "bold",
        },
        {
          value: "PLAN_ID",
          fontWeight: "bold",
        },
        {
          value: "NAME_AR",
          fontWeight: "bold",
        },
        {
          value: "AWQAF",
          fontWeight: "bold",
        },
        {
          value: "QID",
          fontWeight: "bold",
        },
        {
          value: "ROOM_NO",
          fontWeight: "bold",
        },
        {
          value: "ROOM_DETAIL",
          fontWeight: "bold",
        },
      ],
      [
        {
          type: Number,
          value: 1,
        },
        {
          type: Number,
          value: 3,
        },
        {
          type: Number,
          value: 2,
        },
        {
          type: String,
          value: "PLAN_NAME حم لة",
        },
        {
          type: String,
          value: "NAME_AR حملة",
        },
        {
          type: String,
          value: "AWQAF",
        },
        {
          type: String,
          value: "QID",
        },
        {
          type: String,
          value: "ROOM_NO 123",
        },
        {
          type: String,
          value: "ROOM_DETAIL WHEEL CHAIR ACCESSIBLE",
        }
      ],
];

// --------------- START: Date Time Formats ---------------

export const dddd_DD_MMMM_YYYY = "dddd, DD MMMM YYYY";

export const DD_MMM_YYYY = "DD MMM YYYY";

export const DD_MMM_YYYY_HYPHEN = "DD-MMM-YYYY";

export const hh_mm_A = "hh : mm A";

export const DD_MMM_YYYY_hh_mm_a = "DD MMM YYYY hh:mm a";

export const DD_MMM_YYYY_hh_mm_A = "DD MMM YYYY hh:mm A";

export const MM_DD_YYYY_hh_mm_ss_A_SLASH = "MM/DD/YYYY hh:mm:ss A";

export const MM_DD_YYYY_HH_mm_ss_SLASH = "MM/DD/YYYY HH:mm:ss";

export const UTC_DATE_TIME = "YYYY-MM-DDTHH:MM:SSZ";

export const YYYY_MM_DD_HYPHEN = "YYYY-MM-DD";

// --------------- END: Date Time Formats ---------------

// --------------- START: Regex ---------------

export const MATCH_EMAIL = /^[A-Za-z_.0-9-]+@{1}[a-z]+([.]{1}[a-z]{2,4})+$/;

export const MATCH_MOBILE_NO = /^[+-]?(?:\d+\.?\d*|\d*\.?\d+)[\r\n]*$/;

export const MATCH_MOBILE_NO_BACKEND = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/u;

export const MATCH_PASSWORD = /^(?=.*[A-Z])(?=.*[!@#$%^&*()'"])[A-Za-z\d!@#$%^&*()'"](?!\s).{5,19}$/;

export const MATCH_INTEGER = /^[0-9]*$/;

export const MATCH_INTEGER_WITH_PLUS = /^[0-9+]*$/;

export const MATCH_DOUBLE = /^\d*\.?\d{0,2}$/;

export const MATCH_DOUBLE_WITHOUT_FRACTION = /^[0-9.]*$/;

// --------------- END : Regex ---------------

// --------------- START: Messages ---------------

export const MSG_UNIVERSAL_ERROR = "The task you are trying to perform is temporarily unavailable. Kindly contact administrator.";

export const MSG_SESSION_EXPIRED = "Session Expired. Please login again.";

export const MSG_CONNECTION_ERROR = "Network connection failure. Please check your internet connection.";

// --------------- END: Messages ---------------
